import { isArray, isEmpty, isObject, isString, size } from 'lodash';

export const validateRequired = (field) => (v) => {
  if (
    !v ||
    (isString(v) && v?.trim()?.length === 0) ||
    (isObject(v) && isEmpty(v)) ||
    (isArray(v) && isEmpty(v))
  ) {
    return `${field} is required.`;
  }
};

export const validatePassword = (v) => {
  if (
    !/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!£$%^#&*(){}+=:;@'<,>.?/¬`])(?=\S+$).{8,}$/.test(
      v
    )
  ) {
    return 'Password must contain at least 8 characters long with 1 uppercase, 1 lowercase, 1 number and 1 special character.';
  }
};

export const validateUsername = (v) => {
  if (v.length < 5) {
    return 'Username at least 5 characters';
  } else if (/[^a-zA-Z0-9@_.]/.test(v)) {
    return 'Username invalid [a-z0-9@._]';
  }
};

export const validateCode = (v) => {
  if (v?.length !== 6 || /[^0-9]/.test(v)) {
    return 'Code must have 6 number.';
  }
};

export const validateEmail = (v) => {
  if (
    // eslint-disable-next-line
    !/^\w+([\.-]{1}\w+)*@\w+([\.-]{1}\w+)*(\.\w{2,3})+$/i.test(v)
  ) {
    return 'Invalid email format ';
  }
};

export const validateNewPassEqualConfirmPass = (v, values, key, depend) => {
  if (v && depend[key] && v !== depend[key]) {
    return 'Password and Confirmation password do not match';
  }
};

export const validatePermissionAndRoleEmpty = (v, values, key, depend) => {
  if (size(v) === 0 && size(depend[key]) === 0) {
    return 'Permissions Or Roles must not empty';
  }
};

export const validateAdvertiseId = (v) => {
  if (
    !/^[0-9abcdef]{8}-[0-9abcdef]{4}-[0-9abcdef]{4}-[0-9abcdef]{4}-[0-9abcdef]{12}$/i.test(
      v
    )
  ) {
    return 'Invalid Advertising ID format.';
  }
};

export const validateNameSdkConfig = (v) => {
  if (/[^a-zA-Z0-9_]/.test(v)) {
    return 'Invalid name format';
  }
};
